import React, {useState} from 'react';
import BarraNavegacao from "../components/BarraNavegacao";
import LogoWebSai from '../assets/logo.png';
import axios from 'axios';
import { RotatingLines } from 'react-loader-spinner';

export default function Permissao() {

    const [pesquisa,setPesquisa] = useState('');
    const [error, setErrors] = useState('d-none');
    const [localizado, setLocalizado] = useState('d-none');
    const [loading, setLoad] = useState(false);
    
    const [identidade, setIdentidade] = useState({});

    const handledChange = (event) => {
        setPesquisa(event.target.value);
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        pesquisarUsuario();
    }

    const pesquisarUsuario = () =>
    {
        if(pesquisa) {
            setLoad(true);
            axios.get(process.env.REACT_APP_API + 'HelpDesk/Buscas/Websai/'+pesquisa, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
            .then(function(response) {
                if(response.data.statusCode === 200)
                {
                    setErrors('d-none');
                    setLocalizado('');

                    response.data.value.forEach((item) => {
                        if(item.servico === 'Identity')
                        {
                            item.registros[0].respostas.forEach((r) => {
                                setIdentidade(identidade => ({...identidade,[r.campo]:[r.valor]}));
                            })
                            
                        }

                        if(item.servico === 'Pessoas')
                        {
                            item.registros[0].respostas.forEach((r) => {
                                setIdentidade(identidade => ({...identidade,[r.campo]:[r.valor]}));
                            })  
                        }

                        if(item.servico === 'Funcionários')
                        {
                            setIdentidade(identidade => ({...identidade,funcionarios:[item.registros]}));
                        }

                        if(item.servico === 'Discentes')
                        {
                            setIdentidade(identidade => ({...identidade,discentes:[item.registros]}));
                        }

                        if(item.servico === 'Perfis')
                        {
                            setIdentidade(identidade => ({...identidade,perfis:[item.registros]}));
                        }

                        if(item.servico === 'Formulários')
                        {
                            setIdentidade(identidade => ({...identidade,formularios:[item.registros]}));
                        }

                    })
                }
                else
                {
                    setErrors('');
                    setPesquisa('');
                    setLocalizado('d-none');
                }
                setLoad(false);
                
            }).catch((error) => {
                sessionStorage.clear();
                window.location.href = process.env.REACT_APP_HOST+"login";
            })
        }
    }

    return (
        <div> 
            <BarraNavegacao/>
            <div className="container">
                <div className="row mt-2">
                    <div className="col-sm-12">
                        <div className="background rounded p-3">
                            <div className="text-center mb-2">
                                <img src={LogoWebSai} alt="Logo" style={{width:150}}/>
                            </div>
                            <p className="text-center fw-bold fs-5 mb-0">PERMISSÕES DE USUÁRIOS</p>
                            <p className="text-center">Visualize aqui informações sobre usuários do sistema WebSAI.</p>
                            <hr/>
                            <div className="bg-white rounded p-3 border mb-2">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="mb-2 col-lg-5">
                                        <div className="input-group mb-3">
                                            <input type="text" name="cpf" value={pesquisa} onChange={handledChange} className="form-control" placeholder="Informe o CPF para pesquisar" aria-label="Informe o CPF ou Email para pesquisar" aria-describedby="button-addon2"/>
                                            <button className="btn btn-outline-secondary" type="submit" id="button-addon2" disabled={loading ? true : false}>
                                                {!loading ? 'Pesquisar' : 'Carregando... '}
                                                <RotatingLines
                                                    strokeColor="black"
                                                    strokeWidth="5"
                                                    animationDuration="0.75"
                                                    width="20"
                                                    visible={loading}
                                                />
                                            </button>
                                        </div>
                                        <div className={"alert alert-warning " + error}>
                                            Não foi possível localizar este usuário
                                        </div>
                                        <div className={ "alert border bg-light " + localizado }>
                                            <strong>Id:</strong> {identidade.Id}<br></br>
                                            <strong>Nome:</strong> {identidade.NomeCompleto}<br></br>
                                            <strong>Nome social:</strong> {identidade.NomeSocial}<br></br>
                                            <strong>CPF: </strong> {identidade.Cpf}<br></br>
                                            <strong>E-mail: </strong> {identidade.Email}<br></br>
                                            <strong>Telefone: </strong> {identidade.PhoneNumber}<br></br>
                                            <strong>Data de Nascimento: </strong> {identidade.DataNascimento}<br></br>
                                            <strong>Nome da mãe:</strong> {identidade.NomeMae}<br></br>
                                            <strong>Nome do pai:</strong> {identidade.NomePai}<br></br>
                                            <strong>Primeiro acesso: </strong> {identidade.PrimeiroAcesso}<br></br>
                                            <strong>Ativo: </strong> {identidade.Ativo}
                                        </div>
                                    </div>
                                    <div className="mb-2 col-lg-7">
                                        
                                        <h5 className={typeof identidade.funcionarios !== "undefined" && identidade.funcionarios[0].length > 0 ? "text-danger" : "text-secondary"}>Funcionário</h5>
                                        {
                                            typeof identidade.funcionarios !== "undefined" ?
                                            identidade.funcionarios[0].map((f) => 
                                                <div className="alert border bg-light">
                                                    <strong>{f.respostas[3].valor}</strong><br></br>
                                                    <div>
                                                        <strong>Emprego:</strong> {f.respostas[4].valor}<br></br>
                                                        <strong>PessoaFuncionarioId:</strong> {f.respostas[0].valor}<br></br>
                                                        <strong>UnidadeId:</strong> {f.respostas[2].valor}<br></br>
                                                        <strong>Ativo:</strong> {f.respostas[5].valor}
                                                    </div>
                                                </div>
                                            ) : null
                                        }
                                        <hr></hr>

                                        <h5 className={typeof identidade.discentes !== "undefined" && identidade.discentes[0].length > 0 ? "text-danger" : "text-secondary"}>Discente</h5>
                                        {
                                            typeof identidade.discentes !== "undefined" ?
                                            identidade.discentes[0].map((f) => 
                                                <div className="alert border bg-light">
                                                    <strong>{f.respostas[4].valor}</strong><br></br>
                                                    <div>
                                                        <strong>Curso:</strong> {f.respostas[6].valor}<br></br>
                                                        <strong>Período:</strong> {f.respostas[7].valor}<br></br>
                                                        <strong>Semestre e ano de ingresso:</strong> {f.respostas[8].valor}º/{f.respostas[9].valor}<br></br>
                                                        <strong>Data de conclusão:</strong> {f.respostas[10].valor}<br></br>
                                                        <strong>Situação:</strong> {f.respostas[11].valor}<br></br>
                                                        <strong>PessoaDiscenteId:</strong> {f.respostas[0].valor}<br></br>
                                                        <strong>CursoId:</strong> {f.respostas[5].valor}<br></br>
                                                        <strong>UnidadeId:</strong> {f.respostas[4].valor}<br></br>
                                                        <strong>Ativo:</strong> {f.respostas[12].valor}
                                                    </div>
                                                </div>
                                            ) : null
                                        }
                                        <hr></hr>

                                        <h5 className={typeof identidade.perfis !== "undefined" && identidade.perfis[0].length > 0 ? "text-danger" : "text-secondary"}>Perfil</h5>
                                        {
                                            typeof identidade.perfis !== "undefined" ?
                                            identidade.perfis[0].map((f) => 
                                                <div className="alert border bg-light">
                                                    <strong>{f.respostas[4].valor}</strong><br></br>
                                                    <div>
                                                        <strong>Vínculo WebSAI:</strong> {f.respostas[4].valor}<br></br>
                                                        <strong>SistemaGrupoPessoaId:</strong> {f.respostas[0].valor}<br></br>
                                                        <strong>Descrição do grupo:</strong> {f.respostas[2].valor}<br></br>
                                                        <strong>UnidadeId:</strong> {f.respostas[3].valor}<br></br>
                                                        <strong>Editado em:</strong> {f.respostas[5].valor}<br></br>
                                                        <strong>Ativo:</strong> {f.respostas[6].valor}
                                                    </div>
                                                </div>
                                            ) : null
                                        }
                                        <hr></hr>

                                        <h5 className={typeof identidade.formularios !== "undefined" && identidade.formularios[0].length > 0 ? "text-danger" : "text-secondary"}>Formulários</h5>
                                        {
                                            typeof identidade.formularios !== "undefined" ?
                                            identidade.formularios[0].map((f) => 
                                                <div className="alert border bg-light">
                                                    <strong>{f.respostas[4].valor}</strong><br></br>
                                                    <div>
                                                        <strong>Vínculo WebSAI:</strong> {f.respostas[2].valor}<br></br>
                                                        <strong>FormularioPessoaId:</strong> {f.respostas[0].valor}<br></br>
                                                        <strong>UnidadeId:</strong> {f.respostas[3].valor}<br></br>
                                                        <strong>Inicio em:</strong> {f.respostas[5].valor}<br></br>
                                                        <strong>Finalizado em:</strong> {f.respostas[6].valor}<br></br>
                                                        <strong>Situação:</strong> {f.respostas[7].valor}<br></br>
                                                        <strong>Ativo:</strong> {f.respostas[8].valor}
                                                    </div>
                                                </div>
                                            ) : null
                                        }
                                        
                                    </div>
                                </div>
                            </form>
                            </div>

                            <hr/>
                            <div className="text-center mt-3">
                                <svg viewBox="0 0 1000 656.5" style={{width:70}}>
                                    <title>Centro Paula Souza</title>
                                    <path fill="#af0916" d="M760 181.2c.8-23.8 11.1-33.3 45.2-33.3H993V81.4H817c-83.2 0-130 35.6-130 103 0 131.5 240.1 104.6 240.1 174.3 0 23.8-12.7 36.5-45.2 36.5H636.3c24.8-30.3 40-69.4 40-114.1 0-112.5-72.9-207.5-196.4-207.5-111.7 0-191.7 84-191.7 209.1v31.1h-84.6c-65.7 0-130.7-42.8-130.7-123.6s65-123.6 130.7-123.6h53.9V0H191C102.2 0 0 68.1 0 190.1s102.2 190.1 190.9 190.1h97.3v276.2h69.7V380.2h132.7v-66.5H357.9v-18.4c0-104.6 55.5-155.3 122-155.3 74.5 0 126.7 54.6 126.7 132.3 0 66.7-36.1 110-93.3 122.8h-88.9v66.5H882c67.3 0 118-34.1 118-106.1 0-136.3-240.9-108.5-240-174.3" className="icon"></path>
                                    <path d="M481.6 560.8c-3.7 1.7-11.2 3.3-20.8 3.3-22.2 0-38.9-12.5-38.9-35.6 0-22 16.7-37 41.1-37 9.8 0 16 1.9 18.7 3.1l-2.4 7.4c-3.9-1.7-9.4-2.9-15.9-2.9-18.4 0-30.7 10.5-30.7 29 0 17.2 11.1 28.3 30.2 28.3 6.2 0 12.5-1.1 16.6-2.9l2.1 7.3zm16.8-21.2c.2 12.4 9.1 17.5 19.4 17.5 7.4 0 11.8-1.2 15.6-2.6l1.8 6.5c-3.6 1.5-9.8 3.1-18.8 3.1-17.4 0-27.8-10.2-27.8-25.5 0-15.2 10-27.2 26.5-27.2 18.4 0 23.3 14.5 23.3 23.8 0 1.9-.2 3.3-.4 4.3h-39.6zm30.1-6.6c.1-5.8-2.7-14.9-14.2-14.9-10.4 0-14.9 8.5-15.8 14.9h30zm22.6-6.7c0-5.2-.1-9.5-.5-13.7h9.1l.6 8.3h.2c2.8-4.8 9.3-9.5 18.7-9.5 7.8 0 20 4.2 20 21.5v30.2H589V534c0-8.1-3.4-14.9-13.1-14.9-6.8 0-12 4.3-13.8 9.4-.4 1.1-.7 2.7-.7 4.3v30.4h-10.3v-36.9zm76.8-28.2v14.5h14.7v7h-14.7v27.3c0 6.2 2 9.8 7.7 9.8 2.7 0 4.7-.3 6-.6l.5 6.9c-2 .7-5.1 1.3-9.1 1.3-4.8 0-8.6-1.4-11.1-3.9-2.9-2.7-4-7.2-4-13.1v-27.6h-8.8v-7h8.8v-12.1l10-2.5zm26.2 30.3c0-6-.1-11-.5-15.8h9l.3 9.9h.5c2.6-6.8 8.7-11.1 15.6-11.1 1.2 0 2 .1 2.9.3v8.6c-1-.2-2.1-.3-3.5-.3-7.2 0-12.4 4.9-13.8 11.8-.2 1.3-.5 2.7-.5 4.3V563h-10.2v-34.6zm88.2 9.1c0 18.7-14.5 26.8-28.1 26.8-15.3 0-27.1-10-27.1-26 0-16.9 12.4-26.8 28-26.8 16.2 0 27.2 10.5 27.2 26m-44.8.5c0 11.1 7.1 19.4 17.1 19.4 9.8 0 17.2-8.2 17.2-19.6 0-8.6-4.8-19.4-16.9-19.4-12.2 0-17.4 10-17.4 19.6m-270.9 47.3c4.9-.7 11.3-1.4 19.5-1.4 10 0 17.4 2.1 22.1 5.9 4.3 3.3 6.9 8.5 6.9 14.7 0 6.4-2.1 11.4-6.1 15-5.4 5.1-14.1 7.7-24 7.7-3 0-5.9-.1-8.2-.6v28.2h-10.2v-69.5zm10.1 33.9c2.2.5 5 .7 8.4.7 12.3 0 19.7-5.3 19.7-15 0-9.3-7.4-13.8-18.6-13.8-4.4 0-7.8.3-9.6.7v27.4zm79.9 35.6l-.8-6.4h-.3c-3.1 4-9.2 7.5-17.3 7.5-11.4 0-17.3-7.2-17.3-14.5 0-12.2 12.1-18.9 34-18.8v-1c0-4.2-1.3-11.7-12.8-11.7-5.3 0-10.7 1.5-14.7 3.7l-2.4-6.1c4.7-2.7 11.5-4.5 18.5-4.5 17.3 0 21.5 10.5 21.5 20.7v18.9c0 4.4.2 8.7.9 12.1h-9.3zm-1.5-25.8c-11.2-.2-23.9 1.6-23.9 11.4 0 5.9 4.4 8.8 9.7 8.8 7.4 0 12-4.2 13.7-8.4.4-1 .6-2 .6-2.9V629zm73.8 12c0 5.2.1 9.8.4 13.8h-9.1l-.6-8.2h-.2c-2.7 4.1-8.6 9.4-18.7 9.4-8.9 0-19.5-4.4-19.5-22.1v-29.5h10.3v28c0 9.6 3.3 16.1 12.6 16.1 6.9 0 11.7-4.3 13.5-8.3.6-1.4.9-3 .9-4.7v-31h10.3V641zm17-60.3h10.3v74.1h-10.3zm58.9 74.1l-.8-6.4h-.4c-3.1 4-9.2 7.5-17.3 7.5-11.4 0-17.3-7.2-17.3-14.5 0-12.2 12.1-18.9 34-18.8v-1c0-4.2-1.3-11.7-12.8-11.7-5.3 0-10.7 1.5-14.7 3.7l-2.3-6.1c4.7-2.7 11.4-4.5 18.6-4.5 17.3 0 21.5 10.5 21.5 20.7v18.9c0 4.4.2 8.7.9 12.1h-9.4zm-1.5-25.8c-11.2-.2-24 1.6-24 11.4 0 5.9 4.4 8.8 9.7 8.8 7.4 0 12-4.2 13.7-8.4.3-1 .6-2 .6-2.9V629zm50.2 14.7c4.5 2.5 11.2 4.6 18.2 4.6 10.4 0 16.5-4.9 16.5-12 0-6.6-4.2-10.3-14.8-14-12.9-4.1-20.8-10-20.8-19.9 0-11 10.1-19.1 25.4-19.1 8 0 13.9 1.7 17.4 3.4l-2.8 7.4c-2.6-1.2-7.8-3.3-15-3.3-10.7 0-14.8 5.7-14.8 10.5 0 6.6 4.8 9.8 15.7 13.6 13.3 4.6 20.1 10.3 20.1 20.7 0 10.9-9 20.2-27.6 20.2-7.6 0-15.9-2-20.1-4.5l2.6-7.6zm110.4-14.6c0 18.7-14.5 26.8-28.1 26.8-15.3 0-27.1-10-27.1-26 0-16.9 12.4-26.8 28-26.8 16.2 0 27.2 10.6 27.2 26m-44.8.5c0 11.1 7.1 19.4 17.2 19.4 9.8 0 17.2-8.3 17.2-19.6 0-8.5-4.8-19.4-16.9-19.4-12.3 0-17.5 10-17.5 19.6m105 11.4c0 5.2.1 9.8.5 13.8h-9.1l-.6-8.2h-.2c-2.7 4.1-8.6 9.4-18.7 9.4-8.9 0-19.5-4.4-19.5-22.1v-29.5h10.3v28c0 9.6 3.3 16.1 12.6 16.1 6.9 0 11.7-4.3 13.5-8.3.6-1.4.9-3 .9-4.7v-31h10.3V641zm10.7 8.5l25.6-29.8c2.4-2.7 4.8-5.1 7.3-7.8v-.2h-30.6v-7.4h43.1l-.1 5.8-25.2 29.3c-2.3 2.8-4.6 5.3-7.2 7.9v.2h33v7.3h-45.9v-5.3zm87.6 5.3l-.8-6.4h-.4c-3.1 4-9.2 7.5-17.3 7.5-11.5 0-17.3-7.2-17.3-14.5 0-12.2 12.1-18.9 34-18.8v-1c0-4.2-1.3-11.7-12.8-11.7-5.3 0-10.7 1.5-14.7 3.7l-2.3-6.1c4.7-2.7 11.4-4.5 18.6-4.5 17.3 0 21.5 10.5 21.5 20.7v18.9c0 4.4.2 8.7.9 12.1h-9.4zm-1.5-25.8c-11.2-.2-23.9 1.6-23.9 11.4 0 5.9 4.4 8.8 9.7 8.8 7.4 0 12-4.2 13.7-8.4.4-1 .6-2 .6-2.9V629z" className="title"></path>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
    
}